export class TipsOpenAction  {
  public static readonly type = '[Tips] TipsOpenAction';
  constructor(public options: { type?:string, count?: number,image?:string}) {}
}
export class TipsCloseAction  {
  public static readonly type = '[Tips] TipsCloseAction';
  constructor() {}
}
